/* Keep in sync with PHPenum.It is important (for now) to keep in the same order as the back end. */
import BackedEnum from '@/enums/BackedEnum';

export default class AreasOfInterestType extends BackedEnum {}

// NOTE: This is the order they will be displayed in on the frontend selector
AreasOfInterestType.Anesthesia = 'ANESTHESIA';
AreasOfInterestType.AnimalWelfare = 'ANIMAL_WELFARE';
AreasOfInterestType.Behavior = 'BEHAVIOR';
AreasOfInterestType.Immunology = 'IMMUNOLOGY';
AreasOfInterestType.Dentistry = 'DENTISTRY';
AreasOfInterestType.Dermatology = 'DERMATOLOGY';
AreasOfInterestType.Emergency = 'EMERGENCY';
AreasOfInterestType.Endocrinology = 'ENDOCRINOLOGY';
AreasOfInterestType.Cardiology = 'CARDIOLOGY';
AreasOfInterestType.Neurology = 'NEUROLOGY';
AreasOfInterestType.Oncology = 'ONCOLOGY';
AreasOfInterestType.Parasitology = 'PARASITOLOGY';
AreasOfInterestType.LaboratoryAnimal = 'LAB_ANIMAL';
AreasOfInterestType.Microbiology = 'MICROBIOLOGY';
AreasOfInterestType.Radiology = 'RADIOLOGY';
AreasOfInterestType.Nutrition = 'NUTRITION';
AreasOfInterestType.Ophthalmology = 'OPHTHALMOLOGY';
AreasOfInterestType.Pathology = 'PATHOLOGY';
AreasOfInterestType.Pharmacology = 'PHARMACOLOGY';
AreasOfInterestType.Preventive = 'PREVENTIVE';
AreasOfInterestType.SportsMedicine = 'SPORTS_MEDICINE';
AreasOfInterestType.SurgerySoftTissue = 'SURGERY_SOFT_TISSUE';
AreasOfInterestType.SurgeryOrthopedics = 'SURGERY_ORTHOPEDICS';
AreasOfInterestType.SurgeryOphthalmology = 'SURGERY_OPHTHALMOLOGY';
AreasOfInterestType.SurgeryNeurology = 'SURGERY_NEUROLOGY';
AreasOfInterestType.Theriogenology = 'THERIOGENOLOGY';
AreasOfInterestType.Toxicology = 'TOXICOLOGY';
AreasOfInterestType.AlternativeMedicine = 'ALTERNATIVE_MEDICINE';
AreasOfInterestType.ForensicMedicine = 'FORENSIC_MEDICINE';
AreasOfInterestType.EndOfLife = 'END_OF_LIFE';

// In PHP, These are added to the bridge table in alphabetical order based on the DB seeder
// In order to use the ->sync() method, we need to be working with these predetermined IDs
// To get around this, we would have to do a get() request to the API to get the values and ID
const syncId = {};
syncId[AreasOfInterestType.Anesthesia] = 1;
syncId[AreasOfInterestType.AnimalWelfare] = 2;
syncId[AreasOfInterestType.Behavior] = 3;
syncId[AreasOfInterestType.Immunology] = 4;
syncId[AreasOfInterestType.Dentistry] = 5;
syncId[AreasOfInterestType.Dermatology] = 6;
syncId[AreasOfInterestType.Emergency] = 7;
syncId[AreasOfInterestType.Endocrinology] = 8;
syncId[AreasOfInterestType.Cardiology] = 9;
syncId[AreasOfInterestType.Neurology] = 10;
syncId[AreasOfInterestType.Oncology] = 11;
syncId[AreasOfInterestType.Parasitology] = 12;
syncId[AreasOfInterestType.LaboratoryAnimal] = 13;
syncId[AreasOfInterestType.Microbiology] = 14;
syncId[AreasOfInterestType.Radiology] = 15;
// syncId[AreasOfInterestType.ImagingDiagnostics] = 16;
syncId[AreasOfInterestType.Nutrition] = 17;
syncId[AreasOfInterestType.Ophthalmology] = 18;
syncId[AreasOfInterestType.Pathology] = 19;
syncId[AreasOfInterestType.Pharmacology] = 20;
syncId[AreasOfInterestType.Preventive] = 21;
syncId[AreasOfInterestType.SportsMedicine] = 22;
syncId[AreasOfInterestType.SurgerySoftTissue] = 23;
syncId[AreasOfInterestType.SurgeryOrthopedics] = 24;
syncId[AreasOfInterestType.SurgeryOphthalmology] = 25;
syncId[AreasOfInterestType.SurgeryNeurology] = 26;
syncId[AreasOfInterestType.Theriogenology] = 27;
syncId[AreasOfInterestType.Toxicology] = 28;
syncId[AreasOfInterestType.AlternativeMedicine] = 29;
syncId[AreasOfInterestType.ForensicMedicine] = 31;
syncId[AreasOfInterestType.EndOfLife] = 32;

AreasOfInterestType.getIdForType = (type) => syncId[type];
